import dynamic from 'next/dynamic';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import PageConH5 from '@/componentsH5/ProductDelta/deltapro-whole-home';
import SEOlinksA from '@/components/SEOlinksA';
import WholeHomePC from '@/components/WholeHome';
import WholeHomeH5 from '@/componentsH5/WholeHome';
import CALandingPage from '@/components/LandingPage/CA';
import { GetServerSidePropsContext } from 'next';

gsap.registerPlugin(ScrollToPlugin);
const PageConPc = dynamic(() => import('@/components/LandingPage'), {
    ssr: true,
});

export default function LandingPage({ SEO }: any) {
    const { isMobile, useRouter, useLang, useEffect } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('landingPage');
    const { t: s } = useLang('wholehome');
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const WholeHome = isMobile ? WholeHomeH5 : WholeHomePC;
    const WHITE_SITE = ['us', 'ca', 'sa', 'za', 'au'];
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    useEffect(() => {
        if (!WHITE_SITE.includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout theme="black" isNoFixed>
            <SEO title={locale === 'us' ? s('seo_title') : t('seo_title')} description={locale === 'us' ? s('seo_desc') : t('seo_desc')} />
            <SEOlinksA locale={locale} list={WHITE_SITE} pathname={'whole-home-backup-power-solution'} />
            <GtmPageLoad />
            {!['us', 'ca'].includes(locale) && (
                <div className={`${css.wholeHomeBackupPowerSolution}`}>
                    <PageCon />
                </div>
            )}
            {['ca'].includes(locale) && <CALandingPage />}
            {['us'].includes(locale) && <WholeHome />}
        </PageLayout>
    );
}
export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    // us重定向
    if (['us'].includes(locale as string)) {
        // 保留参数
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(query)) {
            if (Array.isArray(value)) {
                value.forEach((v) => params.append(key, v));
            } else if (value !== undefined) {
                params.append(key, value as string);
            }
        }
        const queryString = params.toString();
        const destination = `https://us.ecoflow.com/pages/whole-home-generator${queryString ? `?${queryString}` : ''}`;
        return {
            redirect: {
                destination: destination,
                permanent: true,
            },
        };
    }

    return {
        props: {},
    };
}
